import { ComponentType, lazy, ReactNode, Suspense } from "react";

// Custom loader function that throws a specific error on load failure
const loadComponent = <Props extends object>(importFunc: () => Promise<{ default: ComponentType<Props> }>) =>
  lazy(() =>
    importFunc().catch((error: Error) => {
      // This will throw a custom error when the import fails
      throw new Error(`LazyLoadError: ${error.message}`);
    }),
  );

const LOADING_FALLBACK_TEXT = "Loading";

const Fallback = () => {
  return <p>{LOADING_FALLBACK_TEXT}</p>;
};

function LazyLoader<Props extends object>(importFunc: () => Promise<{ default: ComponentType<Props> }>, fallback: ReactNode = <Fallback />) {
  const LazyComponent = loadComponent(importFunc);

  return (props: Props) => (
    <Suspense fallback={fallback}>
      <LazyComponent {...props} />
    </Suspense>
  );
}

export default LazyLoader;
